import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/ui/Icon';
import { cn } from '@/utils';
import Link from 'next/link';
import { FileDto } from '@/features/shared/dtos/file';

type FileItemProps = {
	onRemove?: VoidFunction;
	className?: string;
    file: File | FileDto;
};

export const FileItem = React.memo((props: FileItemProps) => {
	const { file, className, onRemove } = props;
	const { t } = useTranslation();
    const name = file.name;

	return (
		<div className={cn('flex items-center justify-between gap-2', className)}>
            {'url' in file ? <Link href={file.url}>
                <div className="text-ellipsis hover:text-brand-blue hover:underline cursor-pointer whitespace-nowrap overflow-hidden pt-0.5 flex-1">{name}</div>
            </Link>
                :
            <div className="text-ellipsis whitespace-nowrap overflow-hidden pt-0.5 flex-1">{name}</div>
            }

			{!!onRemove && (
				<button
					title={t('consents.remove', { name }) as string}
					type="button"
					aria-label="Remove"
					className="flex items-center"
					onClick={onRemove}
				>
					<Icon name="closeSmall" size={16} className="text-brand-red" />
				</button>
			)}
		</div>
	);
});
